import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '报表维度',
    type: 'AMAR_RD',
}